import { Schema } from 'normalizr';
import { transformUtil } from '@eb/transformation-utils';

import {
    QuestionsCollection,
    InteractiveQuestion,
    QuestionType,
} from '../../models/survey';

const orderSchema = new Schema('order');

export interface OrderResponse {
    survey: Array<{
        answer: null; // TODO: Find proper type
        question_id: string;
        required: boolean;
        trigger: null | {
            choice_id: string;
            parent_question_id: string;
        };
    }>;

    questions: Record<
        string,
        {
            question: {
                text: string;
                html: string;
            };
            choices: Array<{
                answer: {
                    text: string;
                    html: string;
                };
                id: string;
                quantity_available: null | number;
            }>;
            type: QuestionType;
        }
    >;
}

interface Order {
    survey: Array<InteractiveQuestion>;
    questions: QuestionsCollection;
}

const getTransformedOrderFromOrderResponse = (data: OrderResponse) => {
    const transformedOrder = transformUtil({
        response: data,
        schema: orderSchema,
    });

    if (!transformedOrder) {
        return null;
    }

    return transformedOrder.entities.order[transformedOrder.result] as Order;
};

export const getInteractiveQuestionsFromOrderResponse = (
    data: OrderResponse,
) => {
    const order = getTransformedOrderFromOrderResponse(data);

    return order ? order.survey : null;
};

export const getQuestionsCollectionFromOrderResponse = (
    data: OrderResponse,
) => {
    const order = getTransformedOrderFromOrderResponse(data);

    return order ? order.questions : null;
};
